module.exports = __webpack_public_path__ + "media/img/prices/visa-3f6febded8ba45fc4b354cdcda893a1f.svg";